import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import ScriptEditor from './ScriptEditor';

interface AppProps {
  // Future props from Content Hub context can be added here
}

const App: React.FC<AppProps> = () => {
  return (
    <ChakraProvider>
      <ScriptEditor />
    </ChakraProvider>
  );
};

export default App;